import styled from '@emotion/styled';
import React from 'react';
import { POPUP_INDEX } from '../../../styles/constants/priority';
import ConfirmButton from '../button/SimpleButton';
import Span from '../text/Span';
import Title from '../text/Title';
import { LIGHT_BLUE, WHITE } from '../../../styles/constants/color';
import ModalBase from './ModalBase';
import useSwitching from '../../../hooks/common/useSwitching';
import { MODAL_PADDING_HOR } from '../../../styles/constants/size';

const Base = styled.div`
  width: auto;
  max-width: 450px;
  height: auto;

  @media (max-width: calc(300px + ${MODAL_PADDING_HOR} + ${MODAL_PADDING_HOR})) {
    width: 80vw;
  }
`;

const AlertBody = styled.div`
  display: grid;
  grid-template-rows: 2fr auto;
  gap: 16px;
  width: auto;
  height: auto;
  min-width: 220px;
  min-height: 80px;
  text-align: left;

  & > span {
    word-break: break-all;
    justify-self: center;
    align-self: center;
    line-height: normal;
  }
  & > button {
    justify-self: center;
    align-self: end;
  }
`;

/* const NoticeWrapper = styled.div`
  width: auto;
  height: auto;
`;

const Notice = styled.strong`
  display: block;
  margin-bottom: 2px;
  ${fontFrame('400', '13px', '1', LIGHT_BLUE)};

  &:last-of-type {
    margin-bottom: 0;
  }
`; */

interface Props {
  active: boolean;
  title?: string;
  contents: string;
  closeEvent: () => void;
}

/**
 *  경고성 메세지를 전달하는 공통 모달 컴포넌트
 * @param {boolean} active 모달 활성화 여부
 * @param {string} title 제목
 * @param {string} contents 내용
 * @param {function} closeEvent 모달 닫기 이벤트 함수
 *  */
function AlertModal({ active, title = '안내', contents, closeEvent }: Props): JSX.Element {
  const [modalActive, setModalActive] = useSwitching(true); // 확인버튼 클릭 후 closeEvent를 수행하기 위함.
  return (
    <ModalBase
      type='alert'
      active={active}
      zIndex={POPUP_INDEX + 1}
      subTrigger={modalActive}
      closeEvent={closeEvent}
    >
      <Base>
        <Title text={title} />
        <AlertBody>
          <Span fontSize='15px'>{contents}</Span>
          {/* <NoticeWrapper>
            <Notice>※ 문제가 지속될 경우 관리자에게 문의해주세요.</Notice>
          </NoticeWrapper> */}
          <ConfirmButton
            text='확인'
            width='70px'
            backgroundColor={WHITE}
            color={LIGHT_BLUE}
            borderColor={LIGHT_BLUE}
            onClick={setModalActive}
          />
        </AlertBody>
      </Base>
    </ModalBase>
  );
}

export default AlertModal;
